import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { getContextual3ijx86afthbix as getContextual } from './default.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { SortPart1gsioxz0aa07v as SortPart } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPart.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get_indexed3m5d5co25leom as get_indexed,
  get_displayName274cn1h5q1fsg as get_displayName,
} from './annotationReaders.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sortWith4fnm6b3vw03s as sortWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Companion_getInstance2e3h8n26rh23 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1x79l67jvwntn as serializer_0,
  serializer3u3hsxnenk49x as serializer_1,
  serializer1r0h5yakm679b as serializer_2,
  serializer1tw0a8bv7lkga as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializerodflzzf6s3fp as serializer_5,
  serializer36584sjyg5661 as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer3ikrxnm8b29d6 as serializer_8,
  serializer2lw83vwvpnyms as serializer_9,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  CaselessStringSerializer_getInstance1rdo0fmpuy1jg as CaselessStringSerializer_getInstance,
  TrimmedStringSerializer_getInstance27ofsorf7atqs as TrimmedStringSerializer_getInstance,
  TrimmedCaselessStringSerializer_getInstanceyb3lxczh7nmz as TrimmedCaselessStringSerializer_getInstance,
} from '../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Companion_instance3skn40jhkoxyn as Companion_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { Companion_getInstance1trnkq9cty7vr as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance2du03jiluw9jj as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { Companion_getInstanceuedpedmz4g65 as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { Companion_getInstance1puqqwzccfvrg as Companion_getInstance_3 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance,
  InstantIso8601Serializer_getInstance2pw1uiz054ejd as InstantIso8601Serializer_getInstance,
  LocalDateIso8601Serializer_getInstance3gidjo5oele30 as LocalDateIso8601Serializer_getInstance,
  LocalDateTimeIso8601Serializer_getInstance302qwxjrznnmc as LocalDateTimeIso8601Serializer_getInstance,
  LocalTimeIso8601Serializer_getInstanceywsvdjhmwgt0 as LocalTimeIso8601Serializer_getInstance,
  DurationSerializer_getInstance3b3q4n80uazai as DurationSerializer_getInstance,
  DurationMsSerializer_getInstance132uar9zvq19v as DurationMsSerializer_getInstance,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/Serializers.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance_0 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance_0 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { LocalDateTimeIso8601Serializer_getInstance2em1n1hwy5urt as LocalDateTimeIso8601Serializer_getInstance_0 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateTimeSerializers.mjs';
import { LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq as LocalTimeIso8601Serializer_getInstance_0 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalTimeSerializers.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPartSerializer.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance_0,
  FormSelector1zdq40oqbcvms as FormSelector,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_1,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.we0_1 = function_0;
      }
      wi(a, b) {
        return this.we0_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.we0_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function _init_$traverse(this$0, serializer, base) {
  var tmp0_safe_receiver = get_serializableProperties(serializer);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.let' call
      var it = element.j2j();
      var tmp;
      if (it instanceof ContextualSerializer()) {
        tmp = getContextual(this$0.xe0_1.hdt_1, it);
      } else {
        tmp = it;
      }
      var ser = tmp;
      if (SortPathRenderer_getInstance().de1_1.t1(ser.az().h10())) {
        var access = new (DataClassPathAccess())(base, element);
        if (!SortPathRenderer_getInstance().ce1_1.t1(ser.az().h10())) {
          var tmp0 = this$0.ze0_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements = listOf([new (SortPart())(access, true, false), new (SortPart())(access, false, false)]);
          addAll(tmp0, elements);
        } else {
          var tmp0_0 = this$0.ze0_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements_0 = listOf([new (SortPart())(access, true, false), new (SortPart())(access, false, false), new (SortPart())(access, true, true), new (SortPart())(access, false, true)]);
          addAll(tmp0_0, elements_0);
        }
      }
    }
  }
}
function SortPathRenderer$TypeInfo$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = lastOrNull(b.p4a_1.n4q());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_indexed(tmp0_safe_receiver);
  var tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  var tmp0_safe_receiver_0 = lastOrNull(a.p4a_1.n4q());
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : get_indexed(tmp0_safe_receiver_0);
  var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? false : tmp1_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$1);
}
function SortPathRenderer$TypeInfo$toString$lambda(it) {
  return get_displayName(it);
}
var TypeInfoClass;
function TypeInfo() {
  if (TypeInfoClass === VOID) {
    class $ {
      constructor(module_0, serializer) {
        this.xe0_1 = module_0;
        this.ye0_1 = serializer;
        this.ze0_1 = ArrayList().w();
        _init_$traverse(this, this.ye0_1.y4a_1, new (DataClassPathSelf())(this.ye0_1.y4a_1));
        // Inline function 'kotlin.collections.sortByDescending' call
        var this_0 = this.ze0_1;
        if (this_0.p1() > 1) {
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp = SortPathRenderer$TypeInfo$lambda;
          var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
          sortWith(this_0, tmp$ret$0);
        }
      }
      ee1(it) {
        var tmp = it.p4a_1.n4q();
        var path = joinToString(tmp, ' / ', VOID, VOID, VOID, VOID, SortPathRenderer$TypeInfo$toString$lambda);
        var tmp_0;
        if (SortPathRenderer_getInstance().ce1_1.t1(it.p4a_1.t4a().az().h10())) {
          tmp_0 = it.r4a_1 && it.q4a_1 ? path + ' A-Z' : it.r4a_1 ? path + ' Z-A' : it.q4a_1 ? path + ' A-z (case sensitive)' : path + ' z-A (case sensitive)';
        } else {
          tmp_0 = it.q4a_1 ? path + ' Low - High' : path + ' High - Low';
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'TypeInfo');
    TypeInfoClass = $;
  }
  return TypeInfoClass;
}
function SortPathRenderer$TypeInfo$toString$ref(p0) {
  var l = (_this__u8e3s4) => p0.ee1(_this__u8e3s4);
  l.callableName = 'toString';
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var SortPathRendererClass;
function SortPathRenderer() {
  if (SortPathRendererClass === VOID) {
    class $ {
      constructor() {
        SortPathRenderer_instance = this;
        this.ae1_1 = 'Sort Part';
        this.be1_1 = 'com.lightningkite.lightningdb.SortPart';
        this.ce1_1 = setOf([serializer(Companion_getInstance()).az().h10(), serializer_0(StringCompanionObject_instance).az().h10(), CaselessStringSerializer_getInstance().t3m_1.h10(), TrimmedStringSerializer_getInstance().l3m_1.h10(), TrimmedCaselessStringSerializer_getInstance().p3m_1.h10()]);
        this.de1_1 = plus(setOf([serializer_1(BooleanCompanionObject_instance).az().h10(), serializer_2(ByteCompanionObject_instance).az().h10(), serializer_3(ShortCompanionObject_instance).az().h10(), serializer_4(IntCompanionObject_instance).az().h10(), serializer_5(Companion_instance).az().h10(), serializer_6(Companion_getInstance_0()).az().h10(), serializer_7(Companion_getInstance_1()).az().h10(), serializer_8(Companion_getInstance_2()).az().h10(), serializer_9(Companion_getInstance_3()).az().h10(), UUIDSerializer_getInstance().d4r_1.h10(), InstantIso8601Serializer_getInstance().e4r_1.h10(), LocalDateIso8601Serializer_getInstance().g4r_1.h10(), LocalDateTimeIso8601Serializer_getInstance().h4r_1.h10(), LocalTimeIso8601Serializer_getInstance().f4r_1.h10(), InstantIso8601Serializer_getInstance_0().h25_1.h10(), LocalDateIso8601Serializer_getInstance_0().k25_1.h10(), LocalDateTimeIso8601Serializer_getInstance_0().p25_1.h10(), LocalTimeIso8601Serializer_getInstance_0().u25_1.h10(), DurationSerializer_getInstance().i4r_1.h10(), DurationMsSerializer_getInstance().j4r_1.h10()]), this.ce1_1);
      }
      k20() {
        return this.ae1_1;
      }
      f94() {
        return this.be1_1;
      }
      ldu(module_0, selector) {
        var tmp = selector.edu_1;
        var serializer = tmp instanceof SortPartSerializer() ? tmp : THROW_CCE();
        var info = new (TypeInfo())(module_0, serializer);
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          var tmp_0 = _Constant___init__impl__v45mub(info.ze0_1);
          view.mcf(mutable, new (Constant())(tmp_0), SortPathRenderer$TypeInfo$toString$ref(info));
          $this$FormRenderer.fbb(p, view);
          return $this$FormRenderer.jbb(tmp, view);
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      ndu(module_0, selector) {
        var tmp = selector.edu_1;
        var serializer = tmp instanceof SortPartSerializer() ? tmp : THROW_CCE();
        var info = new (TypeInfo())(module_0, serializer);
        var tmp_0 = Companion_instance_1;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, field, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.ebb(p, view);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$0 = info.ee1($this$reactiveScope.baj(readable));
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          $this$ViewRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForObject($, 'SortPathRenderer', VOID, VOID, [Generator(), Generator_0()]);
    SortPathRendererClass = $;
  }
  return SortPathRendererClass;
}
var SortPathRenderer_instance;
function SortPathRenderer_getInstance() {
  if (SortPathRenderer_instance === VOID)
    new (SortPathRenderer())();
  return SortPathRenderer_instance;
}
//region block: exports
export {
  SortPathRenderer_getInstance as SortPathRenderer_getInstance11nnv6lt4yoa7,
};
//endregion

//# sourceMappingURL=SortPathRenderer.mjs.map
